import { SearchClient, algoliasearch as algoliasearchDefault } from 'algoliasearch';

interface SearchRequest {
  indexName: string;
  query?: string;
  params?: Record<string, any>;
}

interface MultipleQueriesOptions {
  requests: SearchRequest[];
}

const algoliasearch = (appId: string, apiKey: string) => {
  const algoliaClient = algoliasearchDefault(appId, apiKey);
  const searchClient: SearchClient = {
    ...algoliaClient,
    search(requests: any) {
      // In Algolia v5, the search method receives the requests array directly
      if (Array.isArray(requests) && requests.every(({ params }) => !params?.query)) {
        return Promise.resolve({
          results: requests.map(() => ({
            hits: [],
            nbHits: 0,
            nbPages: 0,
            page: 0,
            processingTimeMS: 0,
            hitsPerPage: 0,
            exhaustiveNbHits: false,
            query: '',
            params: ''
          }))
        });
      }
      return algoliaClient.search(requests);
    }
  };
  return searchClient;
};

export default algoliasearch;
